export const ModalNames = {
  SHARED_CONFIRM_MODAL: 'SHARED_CONFIRM_MODAL',
};
